// extracted by mini-css-extract-plugin
export default {"root":"SectionFAQ_root__nQU-h","rootHomepage":"SectionFAQ_rootHomepage__yiiZS","content":"SectionFAQ_content__m2juT","title":"SectionFAQ_title__BEeDS"};